import { useContext } from 'react';
import { intentContext } from "../contexts/intentContext.js";
export function useIntents() {
  const {
    intents
  } = useContext(intentContext);
  return intents;
}